import { FC, SVGProps } from 'react'

export const Edit2: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M17.7071 4.78689C18.0896 4.40437 18.7052 4.40437 19.0877 4.78689C19.4702 5.1694 19.4702 5.78494 19.0877 6.16745L11.504 13.7511L9.66324 14.2113L10.1234 12.3706L17.7071 4.78689ZM20.1483 3.72623C19.18 2.75792 17.6147 2.75792 16.6464 3.72623L8.91588 11.4568C8.81976 11.5529 8.75157 11.6733 8.7186 11.8052L7.90486 15.0602C7.84096 15.3158 7.91585 15.5861 8.10213 15.7724C8.28842 15.9587 8.55878 16.0336 8.81436 15.9697L12.0693 15.156C12.2012 15.123 12.3216 15.0548 12.4178 14.9587L20.1483 7.22811C21.1166 6.25981 21.1166 4.69453 20.1483 3.72623ZM5.37749 4.72705C4.06816 4.72705 3 5.79521 3 7.10454V18.4969C3 19.8063 4.06816 20.8744 5.37749 20.8744H16.7699C18.0792 20.8744 19.1474 19.8063 19.1474 18.4969V12.8007C19.1474 12.3865 18.8116 12.0507 18.3974 12.0507C17.9832 12.0507 17.6474 12.3865 17.6474 12.8007V18.4969C17.6474 18.9778 17.2508 19.3744 16.7699 19.3744H5.37749C4.89658 19.3744 4.5 18.9778 4.5 18.4969V7.10454C4.5 6.62363 4.89658 6.22705 5.37749 6.22705H11.0737C11.4879 6.22705 11.8237 5.89126 11.8237 5.47705C11.8237 5.06284 11.4879 4.72705 11.0737 4.72705H5.37749Z"
			fill="currentColor"
		/>
	</svg>
)
